module.exports = "<div class=\"layout-container\">\r\n  <div class=\"layout\">\r\n    <div class=\"w-100 h-80\">\r\n      <psm-section class=\"left w-30 h-100\" [id]=\"2\"></psm-section>\r\n      <psm-section class=\"right w-70 h-100\" [id]=\"0\"></psm-section>\r\n    </div>\r\n    <psm-section class=\"w-100 h-20\" [id]=\"1\"></psm-section>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/presentations/layouts/layouts/threeSectionsLayout2/threeSectionsLayout2.component.html
// module id = ./src/app/views/presentations/layouts/layouts/threeSectionsLayout2/threeSectionsLayout2.component.html
// module chunks = main